import { BaseModel } from './base-model';

export class BaseControlModel implements BaseModel {
  public id: string;
  public name: string;

  public init() {}
}
